import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

export const DocumentsPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">My Documents</h1>
        <p className="text-gray-500">Manage uploaded certificates and ID documents.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Uploaded Documents</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="p-8 border-2 border-dashed rounded-md text-center text-gray-400">No documents uploaded.</div>
          <div className="mt-4 flex justify-end">
            <Button>Upload New Document</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
